import { useFeatureIsOn } from '@growthbook/growthbook-react';

export function useIsContentAiEnabled() {
  return useFeatureIsOn('app__content_ai_enabled');
}
